import type { CarCatalogPlacementRecord } from '@navio/nsdk';
import { formatCatalogYears, type CarProps } from 'noddi-util';
import { NavioLicensePlate } from './NavioLicensePlate';

type CatalogCar = CarProps & {
  catalogPlacement?: CarCatalogPlacementRecord | null;
};

// A named generation stands alone. Years only fill in when the name is blank,
// so an unnamed generation stays short instead of " (2024–2027)".
const generationLabel = (placement: CarCatalogPlacementRecord) =>
  placement.generationName.trim() || formatCatalogYears(placement.generationYearFrom, placement.generationYearTo) || '';

const vehicleLines = (car: CatalogCar) => {
  const identity = [car.make, car.model].filter(Boolean).join(' ');
  const placement = car.catalogPlacement;
  if (!placement) {
    return { identity, detail: null };
  }
  const detail = [generationLabel(placement), placement.modificationName.trim()].filter(Boolean).join(' · ');
  return { identity, detail: detail ? detail : null };
};

type Props = {
  car: CatalogCar;
  showLicensePlate?: boolean;
};

export const CarListVehicleCell = ({ car, showLicensePlate = false }: Props) => {
  const { identity, detail } = vehicleLines(car);
  if (!showLicensePlate && !identity && !detail) {
    return null;
  }

  return (
    <div className='flex max-w-44 flex-col items-start gap-0.5'>
      {showLicensePlate && <NavioLicensePlate car={car} />}
      {identity && <span className='text-sm leading-tight font-medium break-words'>{identity}</span>}
      {detail && <span className='text-xs leading-tight break-words text-muted-foreground'>{detail}</span>}
    </div>
  );
};
